import Vue from 'vue'
import 'vuetify/src/stylus/app.styl'
import manifestJSON from '../public/manifest.json'

import {
	Vuetify,
	VApp,
	VBtn,
	VImg,
	VTimeline,
	VToolbar,
	VBtnToggle,
	VCard,
	VAvatar,
	VChip,
	VCheckbox,
	VDivider,
	VGrid,
	VIcon,
	VList,
	VProgressLinear,
	VTextField
} from 'vuetify'

Vue.use(Vuetify, {
	components: {
		VApp,
		VBtn,
		VImg,
		VTimeline,
		VToolbar,
		VBtnToggle,
		VCard,
		VAvatar,
		VChip,
		VCheckbox,
		VDivider,
		VGrid,
		VIcon,
		VList,
		VProgressLinear,
		VTextField
	},
	theme: {
		primary: manifestJSON.theme_color
	}
})
